import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import HrManagementHeader from "./header/HRManagementHeader";
import { useEffect, useState } from "react";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { DELETE_DTR_FILE, DOWNLOAD_DTR_FILE, EXTRACT_DTR_REPORT, GET_DTR_FILES } from "../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSpinner, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";

interface dtrFilesProps {
    id : number;
    dtr_report_date : string;
    file_name : string;
    file_type : string;
    date_extracted : string;
}

const HrManagementAttendanceReport = () => {

    const [dtrFiles, setDtrFiles] = useState<dtrFilesProps[] | null>(null);
    const [dateRange, setDateRange] = useState({date_start : '', date_end : ''});
    const [generateBtnLoading, setBtnLoading] = useState<boolean>(false);
    const [delBtnLoading, setDelBtnLoading] = useState<boolean>(false);
    const [delId, setDelId] = useState<number | null>(null);
    useEffect(()=>{
        const getFiles = async() => {
            try{
                const dtrFiles = await api.get(GET_DTR_FILES, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const files = dtrFiles.data as dtrFilesProps[];
                setDtrFiles(files);
            }catch(e){}
        }
        if(!generateBtnLoading || !delBtnLoading) getFiles();
    },[generateBtnLoading, delBtnLoading]);

    const handleGenerateDtr = async() => {
        if(dateRange.date_start === '' && dateRange.date_end === '') return alert('Date Range required!');
        setBtnLoading(true);
        try{
            await api.post(EXTRACT_DTR_REPORT, dateRange, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });
            setDtrFiles(null);
            setBtnLoading(false);
        }catch(e){
            const error = e as AxiosError;
            if(!error){
                setDtrFiles(null);
                setBtnLoading(false);
                return alert('Something went wrong!');
            } 
            const err_data = error.response?.data as {msg : string};
            alert(err_data.msg);
            setDtrFiles(null);
            setBtnLoading(false);
        }
    }

    const handleDownloadDTRFile = async(file_name : string) =>{
        try{
            const response = await api.post(DOWNLOAD_DTR_FILE, {file_name : file_name}, {
                responseType: 'blob',
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });

            const url = window.URL.createObjectURL(new Blob([response.data], {
                type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name);
            document.body.appendChild(link);

            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }catch(e){
            alert('Something went wrong!');
        }
    }

    const handleDeleteDtrFile = async(id : number, file_name : string) => {
        try{
            setDelBtnLoading(true);
            setDelId(id);
            await api.delete(DELETE_DTR_FILE+id+'/'+file_name, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });
            setDelBtnLoading(false);
            setDelId(null);
        }catch(e){
            alert('Something went wrong!');
            setDelBtnLoading(false);
            setDelId(null);
        }
    }

    return (
        <div className='content flex'>
            <Helmet>
                <title>Attendance Report</title>
            </Helmet>
            <SideBar />
            <div className='main-content py-4'>
                <HrManagementHeader />
                <div className="my-4">
                    <div className="flex justify-end items-center gap-4 my-2">
                        <div className="flex gap-2">
                            <label>From:</label>
                            <input type="date" onChange={(e)=>setDateRange({...dateRange, date_start : e.target.value})} className="text-box text-sm h-7 cursor-pointer" />
                        </div>
                        <div className="flex gap-2">
                            <label>To:</label>
                            <input type="date" onChange={(e)=>setDateRange({...dateRange, date_end : e.target.value})} className="text-box text-sm h-7 cursor-pointer" />
                        </div>
                        <div>
                            {generateBtnLoading ? (
                             <button type="button" className="button button-vcc-green text-sm bg-green-500 hover:bg-green-500 cursor-not-allowed">
                                 <FontAwesomeIcon icon={faSpinner} className="animate-spin" />&nbsp; Processing....
                             </button>
                            ) : (
                                <button type="button" onClick={handleGenerateDtr} className="button button-vcc-green text-sm">
                                Generate DTR
                            </button>
                            )}
                        </div>
                    </div>
                    <div className="table-container h-full">
                        <table className="w-full h-full border">
                            <thead className="table-fixed-header border">
                                <tr className="bg-orange-200">
                                    <th className='table-headers font-medium'>#</th>
                                    <th className='table-headers font-medium'>File name</th>
                                    <th className='table-headers font-medium'>File type</th>
                                    <th className='table-headers font-medium'>Date extracted</th>
                                    <th className='table-headers font-medium'>Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {dtrFiles ? dtrFiles.map((file, index) => (
                                    <tr className="hover:bg-orange-100">
                                        <td className='table-body px-2'>{index + 1}</td>
                                        <td className='table-body px-2'>{file.file_name}</td>
                                        <td className='table-body px-2'>.{file.file_type}</td>
                                        <td className='table-body px-2'>{file.date_extracted}</td>
                                        <td className='table-body px-2'>
                                            <div className="flex gap-6 justify-center items-center">
                                                <button type="button" onClick={()=>handleDownloadDTRFile(file.file_name)} className="">
                                                    <FontAwesomeIcon icon={faDownload} />
                                                </button>
                                                {delBtnLoading && delId === file.id ? (
                                                    <button type="button" className="text-blue-500 cursor-not-allowed">
                                                        <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                                    </button>
                                                ) : (
                                                    <button type="button" onClick={()=>handleDeleteDtrFile(file.id, file.file_name)} className="text-red-500">
                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )) : Array.from({length : 4}).map((_, index) => (
                                    <tr key={index}>
                                        {[...Array(5)].map((_, colIndex) => (
                                            <td key={colIndex} className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HrManagementAttendanceReport;